<div class="landing">
    <div class="black-section dealing-background">
        <div class="dealing" id="landing">
            <div class="earth-bright">
                <div class="earth">
                    <img src="../../../../assets/home/imgs/earth.png" />
                </div>
                <div class="bright-place">
                    <div class="bright-spich">
                        <h1 *ngIf="hasAmbasador" class="font-color font-height" translate>Land.IfUTrade</h1>
                        <h1 *ngIf="!hasAmbasador" class="font-color font-height" translate>Land.IfAmbasadorTrade</h1>
                    </div>
                    <div class="bright-dash"></div>
                    <div class="bright-text" *ngIf="hasAmbasador">
                        <h1 *ngIf="hasAmbasador" class="font-color font-height" translate>Land.Then4u</h1>
                        <h1 *ngIf="!hasAmbasador" class="font-color font-height" translate>Land.Then4ambasador</h1>
                    </div>
                    <div class="flex-container direction-row flex-center" *ngIf="hasAmbasador">
                        <div class="bright-button">
                            <a class="mark-button button-cut" (click)="toOffer()" translate>Land.WhatWeOffer</a>
                        </div>
                        <div class="bright-button">
                            <a class="mark-button button-cut" (click)="toTools()" translate>Land.WhatTools</a>
                        </div>
                    </div>
                    <div class="flex-container direction-row ambasador font-height" *ngIf="!hasAmbasador">
                        <div class="features">
                            <div class="feature flex-container direction-row align-center"
                                *ngFor="let ambasador of ambasadorCollection">
                                <div class="logo">
                                    <img src="../../../../assets/ambassador/{{ambasador.shortLogoKey}}" />
                                </div>
                                <a [href]="ambasador.redirectUrl">{{ambasador.tittle}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="spich-2">
                <h1 class="font-color font-height">
                    <span class="green-font" translate>Land.OurService0</span>
                    {{'Land.OurService1'|translate}}
                </h1>
            </div>
            <div class="features">

                <div class="feature">
                    <div class="feature-title text-title" translate>
                        Land.FreeTime
                    </div>
                    <div class="feature-divider"></div>
                    <div class="feature-content">
                        <div translate>
                            Land.FreeTimeDesc
                        </div>
                    </div>
                </div>
                <div class="feature">
                    <div class="feature-title text-title" translate>
                        Land.NoMistakes
                    </div>
                    <div class="feature-divider"></div>
                    <div class="feature-content">
                        <div translate>
                            Land.NoMistakesDesc
                        </div>
                    </div>
                </div>
                <div class="feature">
                    <div class="feature-title text-title" translate>
                        Land.Discipline
                    </div>
                    <div class="feature-divider"></div>
                    <div class="feature-content">
                        <div translate>
                            Land.DisciplineDesc
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="white-section offer-background">
        <div class="offer" id='offer'>
            <div class="spich">
                <div> <span translate>Land.WeOffer</span></div>
                <div class="spich-divider"></div>
            </div>
            <div class="offer-block">
                <div class="carousel">
                    <div class="img">
                        <img src="../../../../assets/home/imgs/mobile/img1.png"
                            srcset="../../../../assets/home/imgs/tablet/img1.png 768w" />
                    </div>
                    <div class="img">
                        <img src="../../../../assets/home/imgs/mobile/img2.png"
                            srcset="../../../../assets/home/imgs/tablet/img2.png 768w" />
                    </div>
                    <div class="img">
                        <img src="../../../../assets/home/imgs/mobile/img3.png"
                            srcset="../../../../assets/home/imgs/tablet/img3.png 768w" />
                    </div>
                    <!--<div class="dots flex-container flex-between">
                        <div class="dot"></div>
                        <div class="dot"></div>
                        <div class="dot"></div>
                    </div>-->
                </div>
                <div class="offers">
                    <div class="offer-item">
                        <div class="offer-item-divider"></div>
                        <div class="offer-item-block">
                            <div class="offer-text">
                                <h3 translate>Land.Offer1</h3>
                            </div>
                            <div class="offer-number"><span>01</span></div>
                        </div>
                    </div>
                    <div class="offer-item">
                        <div class="offer-item-divider"></div>
                        <div class="offer-item-block">
                            <div class="offer-text">
                                <h3 translate>Land.Offer2</h3>
                            </div>
                            <div class="offer-number"><span>02</span></div>
                        </div>
                    </div>
                    <div class="offer-item">
                        <div class="offer-item-divider"></div>
                        <div class="offer-item-block">
                            <div class="offer-text">
                                <h3 translate>Land.Offer3</h3>
                            </div>
                            <div class="offer-number"><span>03</span></div>
                        </div>
                    </div>
                    <div class="offer-item">
                        <div class="offer-item-divider"></div>
                        <div class="offer-item-block">
                            <div class="offer-text">
                                <h3 translate>Land.Offer4</h3>
                            </div>
                            <div class="offer-number"><span>04</span></div>
                        </div>
                    </div>
                    <div class="offer-item">
                        <div class="offer-item-divider"></div>
                        <div class="offer-item-block">
                            <div class="offer-text">
                                <h3 translate>Land.Offer5</h3>
                            </div>
                            <div class="offer-number"><span>05</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="black-section tools-background">
        <div class="tools" id='tools'>
            <div class="tools-title">
                <h1 translate>Land.WeHandle0</h1>
                <h1 class="green-font" translate>Land.WeHandle1</h1>
            </div>
            <div class="tool-box grid">
                <input type="radio" name="radio-tool-btn" class="radio-tool" id="tool-1" />
                <div class="tool-item">
                    <label class="tool-label" for="tool-1"></label>
                    <div class="tool-item-number"><span>01</span></div>
                    <div class="tool-item-text">
                        <h5 translate>Land.Handle1</h5>
                    </div>
                </div>


                <input type="radio" name="radio-tool-btn" class="radio-tool" id="tool-2" />
                <div class="tool-item">
                    <label class="tool-label" for="tool-2"></label>
                    <div class="tool-item-number"><span>02</span></div>
                    <div class="tool-item-text">
                        <h5 translate>Land.Handle2</h5>
                    </div>
                </div>

                <input type="radio" name="radio-tool-btn" class="radio-tool" id="tool-3" />
                <div class="tool-item">
                    <label class="tool-label" for="tool-3"></label>
                    <div class="tool-item-number"><span>03</span></div>
                    <div class="tool-item-text">
                        <h5 translate>Land.Handle3</h5>
                    </div>
                </div>


                <input type="radio" name="radio-tool-btn" class="radio-tool" id="tool-4" />
                <div class="tool-item">
                    <label class="tool-label" for="tool-4"></label>
                    <div class="tool-item-number"><span>04</span></div>
                    <div class="tool-item-text">
                        <h5 translate>Land.Handle4</h5>
                    </div>
                </div>

                <input type="radio" name="radio-tool-btn" class="radio-tool" id="tool-5" />
                <div class="tool-item">
                    <label class="tool-label" for="tool-5"></label>
                    <div class="tool-item-number"><span>05</span></div>
                    <div class="tool-item-text">
                        <h5 translate>Land.Handle5</h5>
                    </div>
                </div>


                <input type="radio" name="radio-tool-btn" class="radio-tool" id="tool-6" />
                <div class="tool-item">
                    <label class="tool-label" for="tool-6"></label>
                    <div class="tool-item-number"><span>06</span></div>
                    <div class="tool-item-text">
                        <h5 translate>Land.Handle6</h5>
                    </div>
                </div>


                <input type="radio" name="radio-tool-btn" class="radio-tool" id="tool-7" />
                <div class="tool-item">
                    <label class="tool-label" for="tool-7"></label>
                    <div class="tool-item-number"><span>07</span></div>
                    <div class="tool-item-text">
                        <h5 translate>Land.Handle7</h5>
                    </div>
                </div>


                <input type="radio" name="radio-tool-btn" class="radio-tool" id="tool-8" />
                <div class="tool-item">
                    <label class="tool-label" for="tool-8"></label>
                    <div class="tool-item-number"><span>08</span></div>
                    <div class="tool-item-text">
                        <h5 translate>Land.Handle8</h5>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div *ngIf="hasAmbasador" class="white-section plan-background">
        <div class="plan" id="pricing" #subscription>
            <div class="plan-title">
                <h1 translate>UserInfo.Subscription</h1>
            </div>
            <partner-plan *ngIf="hasJsonPlan" [planFileName]="ambasador.planJson"></partner-plan>
            <default-plan *ngIf="!hasJsonPlan" [value]="defaultPriceModel"></default-plan>
        </div>
    </div>
    <div class="black-section contacts-background">
        <div class="contacts" id="contacts">
            <div class="contacts-header">
                <div class="contacts-logo" (click)="scrollTop()">
                    <img src="../../../../assets/mt/mtlogo_dark.svg" />
                </div>
                <div class="contacts-title">
                    <h1 translate>Land.Contacts</h1>
                    <img src="../../../../assets/home/arrow-right-bottom.svg" />
                </div>
                <div class="contacts-text">
                    <div>Email: <a href="mailto:{{contactEmail}}" target="_blank">{{contactEmail}}</a></div>
                    <div>Telegram: <a href="https://t.me/{{contactTelegram}}" target="_blank">{{contactTelegram}}</a>
                    </div>
                    <div>Discord Channel: <a href="{{contactDiscord}}" target="_blank">Mark Tools Screener</a></div>
                </div> 
                <div class="contact-abuot">
                    <h3 translate>Land.Copyright</h3>
                </div>
            </div> 
        </div>
    </div>
</div>
